export default __webpack_public_path__ + "static/media/arrow-right.c8ea8f92.svg";